/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

export type ExportDataStreamsCsvBodyHeaderRowsItem =
	(typeof ExportDataStreamsCsvBodyHeaderRowsItem)[keyof typeof ExportDataStreamsCsvBodyHeaderRowsItem];

export const ExportDataStreamsCsvBodyHeaderRowsItem = {
	DATA_STREAM_ID: "DATA_STREAM_ID",
	FRAGMENT_ID: "FRAGMENT_ID",
	DATA_STREAM_NAME: "DATA_STREAM_NAME",
	DEVICE_NAME: "DEVICE_NAME",
	DEVICE_VERDI_ID: "DEVICE_VERDI_ID",
	ZONE: "ZONE",
	SENSOR_TYPE: "SENSOR_TYPE",
	UNIT_CATEGORY: "UNIT_CATEGORY",
	UNIT: "UNIT",
	DEPTH: "DEPTH",
	HEIGHT: "HEIGHT",
	LATITUDE: "LATITUDE",
	LONGITUDE: "LONGITUDE",
} as const;
